import { useRecoilValue } from "recoil";
import { userCustomerApplicationState, userCustomerApplicationWizardState } from "../../../state";
import { CustomerApplicationForm } from "./form/CustomerApplicationForm";
import {
  mapCustomerApplicationApiToState,
  mapCustomerApplicationApiToStep1,
} from "./mapCustomerApplicationApiToState";
import { formDefaultState } from "./formState/formState";
import { FullWidthSpinner } from "../../FullWidthSpinner";

export const CustomerApplicationView = () => {
  const customerApplication = useRecoilValue(userCustomerApplicationState);
  const wizardStateData = useRecoilValue(userCustomerApplicationWizardState);

  const state =
    customerApplication !== null
      ? mapCustomerApplicationApiToState(customerApplication.submission)
      : wizardStateData !== null
      ? mapCustomerApplicationApiToState(wizardStateData)
      : formDefaultState;

  const step1State =
    customerApplication !== null
      ? mapCustomerApplicationApiToStep1(customerApplication.submission)
      : wizardStateData !== null
      ? mapCustomerApplicationApiToStep1(wizardStateData)
      : null;

  if (step1State === null) {
    return <FullWidthSpinner />;
  }

  return <CustomerApplicationForm defaultState={state} defaultStep1State={step1State} />;
};
